export default __webpack_public_path__ + "static/media/four_tou1.058387f4.png";